export default function reportPackageGeneratedPackagesDirective() {
  return {
    template: require('./report-package-generated-packages.html'),
    controller: 'PRReportPackageGeneratedPackagesController',
    controllerAs: 'prReportPackageGeneratedPackagesVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportPackage: '=',
    },
  };
}
